import ResultTable from "../../../components/table/ResultTable";
import {MessageCodes} from "../MessageCodes";
import numWords from "num-words";
import ToUpper from "../ToUpper";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import EmptyLine from "../EmptyLine";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import HecRasHelper from "../../../helpers/HecRasHelper";

export function C1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}
const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.NR001.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) cross sections at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NR002.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) new cross sections are added at the following river stations.
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.CXS05.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the conveyance weighted Manning’s n values between the following newly added cross sections and the existing immediate US cross section in the base model.
                        <EmptyLine />
                    </ResultText>
                    <ResultText>
                        {
                            row?.data?.map(r => (
                                <ResultTable>
                                    <ResultHeader>
                                        <ResultRow>
                                            <ResultHeaderCell></ResultHeaderCell>
                                            <ResultHeaderCell></ResultHeaderCell>
                                            <ResultHeaderCell colSpan={3}>Conveyance Weighted Manning's n</ResultHeaderCell>
                                        </ResultRow>
                                        <ResultRow>
                                            <ResultHeaderCell></ResultHeaderCell>
                                            <ResultHeaderCell>River Station</ResultHeaderCell>
                                            <ResultHeaderCell style={{textAlign: 'right'}}>LOB</ResultHeaderCell>
                                            <ResultHeaderCell style={{textAlign: 'right'}}>Channel</ResultHeaderCell>
                                            <ResultHeaderCell style={{textAlign: 'right'}}>ROB</ResultHeaderCell>
                                        </ResultRow>
                                    </ResultHeader>
                                    <ResultBody>
                                        <ResultRow>
                                            <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'bold'}}>Cross Section</ResultHeaderCell>
                                            <ResultBodyCell style={{textAlign: 'left'}}>
                                                <ComparisonCSName csName={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r?.base?.lob, r?.cmp?.lob)}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r?.base?.chn, r?.cmp?.chn)}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r?.base?.rob, r?.cmp?.rob)}</ResultBodyCell>
                                        </ResultRow>
                                        <ResultRow>
                                            <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'bold'}}>US Cross Section</ResultHeaderCell>
                                            <ResultBodyCell style={{textAlign: 'left'}}>
                                                <ComparisonCSName csName={r?.base?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{r?.base?.lob}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{r?.base?.chn}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{r?.base?.rob}</ResultBodyCell>
                                        </ResultRow>
                                    </ResultBody>
                                </ResultTable>
                            ))
                        }
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NRICS001.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) Internal Bridge Cross Sections at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NRICS002.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) new Internal Bridge Cross Sections are added at the following river stations.
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.CXS04.error_id: {
            return (
                <>
                    <ResultText>
                        River stations of the following {row?.data?.length} cross-sections are revised due to realignment of the stream centerline. They are associated as follows for comparison purposes.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable >
                        <ResultHeader col>
                            <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(30), textAlign: 'start'}}>
                                Associated Cross Sections
                            </ResultHeaderCell>
                        </ResultHeader>
                        <ResultHeader>
                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>{globalVariables?.sel_plan_title || 'base'}</ResultHeaderCell>
                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>{globalVariables?.tar_plan_title || 'base'}</ResultHeaderCell>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{textAlign: 'start'}}>
                                                <ComparisonCSName csName={r?.cross_section} csNameVal={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'start'}}>
                                                {r?.assoc_cross_section}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.CXY08.error_id: {
            const item = row?.data?.[0]
            const usPart = item?.us_status ? `${item.us_status} US of RS ${item.us_rs}` : null
            const dsPart = item?.ds_status ? `${item.ds_status} DS of RS ${item.ds_rs}` : null
            const parts = [usPart, dsPart].filter(Boolean).join(' and ')
            return (
                <>
                    <ResultText>
                        The base plan is {parts}. This resulted in {item?.reach_length_diff} ft {item?.direction} in reach length.
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}